import { render, staticRenderFns } from "./HanoiStarExtra.vue?vue&type=template&id=66cfce68&"
import script from "./HanoiStarExtra.vue?vue&type=script&lang=js&"
export * from "./HanoiStarExtra.vue?vue&type=script&lang=js&"
import style0 from "./HanoiStarExtra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports